<template>
  <div class="product-credit">
    <DefTitle :result="3">
      <h3>
        {{ result.NAME }}
      </h3>
    </DefTitle>
    <!--    <DefContent v-html="result.DESCRIPTION" />-->
    <ProductInstallments :result="result" />
    <!--        <DefTitle :result="3">-->
    <!--            <h3>-->
    <!--                <DefProgramMe tag="span">-->
    <!--                    Моно Банк-->
    <!--                </DefProgramMe>-->
    <!--            </h3>-->
    <!--        </DefTitle>-->
    <!--        <ProductInstallments :result="result" />-->
    <DefButtonPrimary @click="handlerBuy">{{ basketMessages.buy }}</DefButtonPrimary>
  </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import { useStore } from '@/store';
import DefTitle from '@components/Def/DefTitle/DefTitle.vue';
import DefContent from '@components/Def/DefContent/DefContent.vue';
import ProductInstallments from '@components/Product/ProductInstallments/ProductInstallments.vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';

const props = defineProps(['result']);
const store = useStore();
const basketMessages = computed(() => store.state.basket.data.messages);
const product = computed(() => store.state.product.data.product);

const handlerBuy = async () => {
  try {
    const params = {
      action: 'createCreditOrder',
      productId: product.value?.offer?.id || product.value?.id,
      quantity: product.value?.price?.quantity || 1,
    };
    const checkoutData = {
      CODE: props.result.CODE,
      PARTS_COUNT: props.result.payData.PARTS_COUNT,
    };

    sessionStorage.setItem('createCreditOrder', JSON.stringify(checkoutData));

    const { status, data } = await axios.post('/ajax/', params);

    if (data?.pathToCheckout) {
      location.href = data.pathToCheckout;
    }
  } catch (err) {
    console.error(err);
  }
};
</script>

<style lang="scss" scoped>
.product-credit {
  :deep(.product-installments) {
    margin-bottom: 24px;
  }
  :deep(.def-content) {
    font-size: rem(16);
    margin-top: 10px;
  }
  :deep(.def-button-primary) {
    display: flex;
    margin-left: auto;
    padding: 0 30px;
    margin-bottom: 24px;
  }
}
</style>
